import { useCallback } from "react";
import { useController, useFormContext } from "react-hook-form";
import { useGetApi } from "src/hooks";
import { useSelector } from "src/redux/hooks";

interface Props {
  id: string;
}

const SignatureCell = ({ id }: Props) => {
  const currentSignature = useSelector(
    state => state.generatorSlice.currentSignature,
  );
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({
    control,
    name: id,
  });

  const mapSignature = useCallback(
    (data: any) => {
      onChange(data.data.signature);
    },
    [onChange],
  );

  useGetApi({
    request: "get-user-sig",
    body: {
      params: {
        userid: currentSignature,
      },
    },
    mapper: mapSignature,
  });

  return (
    <div style={{ maxHeight: "40px", width: "250px" }}>
      <img id="signature-img" style={{ maxHeight: "40px" }} src={value}></img>
    </div>
  );
};

export default SignatureCell;
